import React, { Component } from 'react'
import PopupWindow from './PopupWindow'
import { connect } from 'react-redux';
import * as StatisticActions from '../../actions/statisticActions';
import { bindActionCreators } from 'redux';
import StatsBaseWindow from './StatsBaseWindow'
import reactStringReplace from 'react-string-replace'
import { getInterval } from '../../components/Pitch/gameJson'
import { delay } from '../Animations/helper'

class TextWindow extends StatsBaseWindow {

    static propTypes = {
        top: React.PropTypes.number,
        left: React.PropTypes.number
    }

    static defaultProps = {
        top: 10,
        left: 10
    }

    constructor(props) {
        super(props);
        this.items = [];
        let currentMinute = 0;

        for (var index = 0; index < window.Json.game.length; index++) {
            var event = window.Json.game[index];
            if(currentMinute != event.minute) {
                this.items.push({
                    num: event.num,
                    type: 'minute',
                    text: event.minute + ' минута'
                });
                currentMinute = event.minute;
            }
            if(event.messages != null)
                for (var j = 0; j < event.messages.length; j++) {
                    if(event.messages[j].mes != null)
                        this.items.push({
                            num: event.num,
                            type: 'text',
                            text: this.processMessage(event.messages[j].mes)
                        });
                }
        }
    }

    processMessage(message) {
        message = message.replace(/\(.[^\(]+\)/g, '');
        return message;
    }

    componentDidMount() {
        this.container = document.getElementById("text_window_container");
        this.scrollDown();
    }

    componentWillReceiveProps(nextProps){
        if(this.props.currentEvent != nextProps.currentEvent) {
          let time = 0;
          if(Math.abs(this.props.currentEvent - nextProps.currentEvent) > 1) {
            time = 5;
          }
          else {
            time = this.readTime(nextProps.currentEvent);
          }
          this.updateAfter(time);
        }
      }
  
    updateAfter(time) {
        delay(time*this.props.gameSpeed).then(() => {
            this.forceUpdate();
            this.scrollDown();
        })
    }

    readTime(eventNum) {
        return getInterval(eventNum-1);
    }
  
    shouldComponentUpdate(nextProps, nextState) {
        if(nextProps.height != this.props.height || nextProps.width != this.props.width)
            return true;

        return false;
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.currentEvent != this.props.currentEvent)
            this.scrollDown();
    }

    scrollDown() {
        if(!this.props.is_cut_down)
            this.container.scrollTop = this.container.scrollHeight;
    }

    getPlayerData(id) {
        let players = id > 20 ? this.props.away.Players : this.props.home.Players;
        let team = id > 20 ? this.props.away : this.props.home;
        let player = this.getPlayer(players, id);
        if(player == null || player.Number == null)
            debugger;
        return {
            number: player.Number,
            shirtBackground: team.Back,
            shirtTextColor: team.Color,
            shirtBorderColor: team.Color
        } 
    }

    getPlayer(players, index) {
        let num = index % 20;
        if(index == 20 || index == 40)
            num = 20;
        for (var i = 0; i < players.length; i++) {
            var player = players[i];
            if(player.Num == num)
                return player;
        }
    }

    onResize(width, height) {

    }

    render() {     
        const { close_stats_window } = this.props.StatisticActions;

        const divStyle = {
            height: this.props.height + 'px'
        };

        return (<PopupWindow header="Текстовый отчет" resizable={true} width={this.props.width} height={this.props.height} onResizeStop={this.onResizeStop.bind(this)} onResize={this.onResize.bind(this)} is_cut_down={this.props.is_cut_down} onDragStop={this.onDragStop.bind(this)} onToggleCutDown={this.onToggleCutDown.bind(this)} top={this.position.top}  left={this.position.left} onClose={() => (close_stats_window(this.props.id))}>
                    <div id="text_window_container" ref={(ref) => this.container = ref} className="text_container">                                               
                        {this.items.filter((item)=> item.num < this.props.currentEvent && item.num > this.props.currentEvent - 30).map((item, i)=> {                           
                            if(item.type == 'minute')
                                return <div key={"minute"+item.num} className="minute"><b>{item.text}</b></div>
                            else
                                return <div key={"text_"+item.num+'_'+ i}>
                                    {reactStringReplace(item.text, /\[([0-9]{1,})\]/, 
                                    (id, i) => { 
                                        let {number, shirtBackground, shirtTextColor, shirtBorderColor} = this.getPlayerData(parseInt(id, 10)); 
                                        return (<PlayerShape key={"shape"+id} number={number} shirtBackground={shirtBackground} shirtTextColor={shirtTextColor} shirtBorderColor={shirtBorderColor}/>)
                                        }
                                    )}
                                        </div>
                        })}
                    </div>
                </PopupWindow>)
    }
}

function mapStateToProps(state, ownProps) {
    let width = state.statisticWindows[ownProps.id].width;
    let height = state.statisticWindows[ownProps.id].height;

    width = width == null || width == NaN ? 400 : width;
    height = height == null || height == NaN ? 300 : height;
    
    return {
        position: state.statisticWindows[ownProps.id].position,
        is_cut_down: state.statisticWindows[ownProps.id].is_cut_down,
        home: state.HomeTeam,
        away: state.AwayTeam,
        currentEvent: state.currentEvent,
        gameSpeed: state.gameSpeed,
        height: height,
        width: width
    };
}

function mapDispatchToProps(dispatch) {
    return {
        StatisticActions: bindActionCreators(StatisticActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(TextWindow)

class PlayerShape extends Component {
    static propTypes = {
        shirtBackground: React.PropTypes.string.isRequired,
        shirtTextColor: React.PropTypes.string.isRequired,
        shirtBorderColor: React.PropTypes.string.isRequired,
        number: React.PropTypes.number
    }

    
    getColors() {
        return {
            background: this.props.shirtBackground,
            color: this.props.shirtTextColor,
            borderColor: this.props.shirtBorderColor
          }
      }
    
    render() {
        const playerShapeStyle = this.getColors();
        
        return (<div className="player_container medium_size">
                    <div style={playerShapeStyle} className="player_shape">
                        <div className="player_number">{this.props.number}</div>
                    </div>
                </div>)
    }
}



/** WEBPACK FOOTER **
 ** ./src/components/PopupStats/TextWindow.js
 **/